import { render, staticRenderFns } from "./addressBook-popup.vue?vue&type=template&id=b30b374e"
import script from "./addressBook-popup.vue?vue&type=script&lang=js"
export * from "./addressBook-popup.vue?vue&type=script&lang=js"
import style0 from "./addressBook-popup.vue?vue&type=style&index=0&id=b30b374e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports